import { connect } from 'react-redux';
import ResetPassword from '../../components/Auth/ResetPassword';
import { push } from 'react-router-redux';
import {
  sendLogin,
  showForgotPassword,
	forgotPassword,
	logout,
  resetPassword,
  setEmail,
	setPassword,
	mountSession,
	sendPasswordRecoveryEmail,
	getAPIBuildNumber
} from '../../actions/App';

function mapStateToProps(state) {
	const { loginDialog, forgotPassword, loggedIn, email, password, userId,  token, roleId, roleName,
		clients, selected_client, loginUserDetail,apiBuildNumber,
		sendRecoveryEmailSuccess, sendRecoveryEmailFailMessage } = state.app
	return {
		loginDialog,
		forgotPassword,
		email,
		password,
		loggedIn,
		userId,
		roleId,
		roleName,
		clients,
		selected_client,
		apiBuildNumber,
		token,
		loginUserDetail,
		sendRecoveryEmailFailMessage,
		sendRecoveryEmailSuccess,
		location: {
			path: state.routing.location.pathname,
			queryStep: state.routing.location.match ? state.routing.location.match.params.step : '',
			query: state.routing.location.match ? state.routing.location.match.params : null
		}
	};
}

function mapDispatchToProps(dispatch) {
	return {
		mountSession: (session) => {
			dispatch(mountSession(session));
		},

		handleLoginSubmit: (email, password) => {
			dispatch(sendLogin(email, password));
		},

		handleLogout: () => {
			window.localStorage.clear()
			dispatch(logout())
			dispatch(push("/"))
		},

		handleForgotPassword: () => {
			dispatch(showForgotPassword());
		},

		handleForgotPasswordSubmit: (email) => {
			dispatch(forgotPassword(email));
		},

		handleResetPassword: (token, email, password) => {
			dispatch(resetPassword(token, email, password));
		},

		setEmail: (email) => {
			dispatch(setEmail(email));
		},

		setPassword: (password) => {
			dispatch(setPassword(password));
		},
		
		sendPasswordRecoveryEmail: (email, secretKey) => {
			dispatch(sendPasswordRecoveryEmail(email, secretKey))
		},
		getAPIBuildNumber: () => {
			dispatch(getAPIBuildNumber());
		}
	};
}

const ResetPasswordContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ResetPassword);

export default ResetPasswordContainer;


// WEBPACK FOOTER //
// ./src/containers/Auth/ResetPassword.js